import PropTypes from "prop-types"
import { useContext } from "react"
import { MultiContext } from "~/contexts/MultiContext"
import { classNames } from "~/utils/classNames"
import { useConditionalState } from "~/utils/useConditionalState"

PlainFrame.propTypes = {
  position: PropTypes.number.isRequired,
  overrides: PropTypes.object,
  children: PropTypes.node.isRequired,
}
export function PlainFrame({ position, overrides, children }) {
  return (
    <BaseFrame position={position} overrides={overrides}>
      {children}
    </BaseFrame>
  )
}

Frame.propTypes = {
  position: PropTypes.number.isRequired,
  overrides: PropTypes.object,
  children: PropTypes.node.isRequired,
}
export function Frame({ position, overrides, children }) {
  const { dimensions, focus } = useContext(MultiContext)
  const focusClasses = "col-start-1 row-start-1 col-span-4 row-span-4 z-10 mx-auto"
  const extras = {
    applied: position === focus,
    classes: focusClasses,
    styles: dimensions.frame.focus,
  }

  return (
    <BaseFrame position={position} overrides={overrides} extras={extras}>
      {children}
    </BaseFrame>
  )
}

BaseFrame.propTypes = {
  position: PropTypes.number.isRequired,
  extras: PropTypes.shape({
    applied: PropTypes.bool.isRequired,
    classes: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    styles: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  }),
  overrides: PropTypes.shape({
    baseClasses: PropTypes.string,
    frameClasses: PropTypes.string,
  }),
  children: PropTypes.node.isRequired,
}
function BaseFrame({ position, extras = {}, overrides = {}, children }) {
  const { gridConfig, layout, focus, focusRef, dimensions, breakpoint } = useContext(MultiContext)
  const large = gridConfig.large.includes(position)
  const singleColumn = breakpoint === ""

  const positionStyles = gridConfig.positionStyles[position]
  const baseClasses = `
    ${large ? "sm:col-span-2 sm:row-span-2" : ""}
    ${positionStyles}
    ${position > layout ? "hidden" : ""}
    ${focus ? "opacity-25 pointer-events-none" : ""}
    ${overrides?.baseClasses}
  `

  const durationClass = useConditionalState({
    bool: extras?.applied,
    defaultCase: "duration-500",
    trueCase: "duration-0",
  })
  const frameClasses = `relative w-fit bg-neutral-900 transition-all ${durationClass} ${overrides?.frameClasses}`

  const baseStyles = singleColumn
    ? { ...dimensions.frame.single }
    : large
    ? { ...dimensions.frame.large }
    : { ...dimensions.frame.normal }

  return (
    <>
      <div
        ref={focusRef}
        className={classNames(extras?.applied ? extras.classes : baseClasses, frameClasses)}
        style={extras?.applied ? extras.styles : baseStyles}
      >
        {children}
      </div>
    </>
  )
}
